/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AtolFiscalResult { 
    type?: string;
    fiscalDocumentNumber: number;
    fiscalDocumentSign: string;
    fiscalDocumentDateTime: string;
    shiftNumber?: number;
    fnNumber: string;
    registrationNumber?: string;
    fnsUrl?: string;
    total: number;
    fiscalReceiptNumber?: number;
    serialNumber?: string;
    taxationType?: string;
}

